import { Injectable} from '@angular/core';
import {Observable, Subject } from "rxjs";
import {Alert, CustomAlert, ResponseAlert} from "../shared";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private _showSource = new Subject<Alert | CustomAlert>();
  showSource$ = this._showSource.asObservable();

  private _hideSource = new Subject<any>();
  hideSource$ = this._hideSource.asObservable();


  show(config: Alert | CustomAlert):Observable<ResponseAlert>  {
    this._showSource.next(config);
    return this.hideSource$;
  }

  hide(obj?: any) {
    this._hideSource.next(obj);
  }



}
